
import React, { useEffect, useState } from "react";
import styles from "./AlertPopup.module.css";

const AlertPopup = ({ type = "info", message = "", onClose }) => {
  const [animateOut, setAnimateOut] = useState(false);

  useEffect(() => {
    let timer;

    if (type === "success" || type === "info") {
      timer = setTimeout(() => {
        setAnimateOut(true);
        setTimeout(() => onClose(), 500);
      }, 6000);
    }

    return () => clearTimeout(timer);
  }, [type, onClose]);

  return (
    <div
      className={`${styles.alert} ${styles[type]} ${animateOut ? styles.fadeOut : styles.fadeIn}`}
    >
      <span className={styles.message}>
        {type === "error" && "❌ "}
        {type === "warning" && "⚠️ "}
        {type === "success" && "✅ "}
        {type === "info" && "ℹ️ "}
        {message}
      </span>

      {(type === "error" || type === "warning") && (
        <button className={styles.closeBtn} onClick={onClose}>
          ×
        </button>
      )}
    </div>
  );
};

export default AlertPopup;
